// @vendors
const { Promise } = require('es6-promise');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');

const requestPropertyValueDefinedInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_PROPERTY_VALUE_DEFINED_REQUEST
});

const requestPropertyValueDefinedSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_PROPERTY_VALUE_DEFINED_SUCCESS,
    data: data
});

const requestPropertyValueDefinedFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_PROPERTY_VALUE_DEFINED_FAILURE,
    data: {
        error
    }
});

const requestPropertyValueDefined = idExpediente => (dispatch, getState) => {
    const currentState = getState().mortgageRequestPropertyValueDefined;
    const isAlreadyFetching = currentState.get('isFetching');

    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                idExpediente
            }
        };
        dispatch(requestPropertyValueDefinedInProgress());

        return APIGet(
            dispatch,
            apiURLBuilder.getURL('mortgageRequestPropertyValueDefined'),
            requestData
        )
            .then(response => dispatch(requestPropertyValueDefinedSuccess(response)))
            .catch(error => {
                if (!!error.error) {
                    dispatch(requestPropertyValueDefinedFailure(error));
                } else {
                    throw error;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const resetState = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_DEFINED_RESET
});

const resetPropertyValueState = () => dispatch => dispatch(resetState());

module.exports = {
    requestPropertyValueDefined,
    resetPropertyValueState
};
